import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgExclamationMark = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.75 21.875a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0ZM14 17.5a.875.875 0 0 0 .875-.875V5.25a.875.875 0 0 0-1.75 0v11.375A.875.875 0 0 0 14 17.5Z" />
  </svg>
);
export default SvgExclamationMark;
